/**
 * iter236 · Purchase (inward) calendar.
 *
 * Owner's rule: only a goods-receipt note means material actually arrived.
 * Vendor bills are the money layer and purchase orders are expected markers,
 * so arrived kg can never be inflated by paperwork.
 */
import React from 'react';
import { ArrowDownLeft } from 'lucide-react';
import MovementCalendar from '../components/movements/MovementCalendar';

export default function PurchaseCalendar() {
  return (
    <div className="space-y-4" data-testid="purchase-calendar-page">
      <div>
        <h1 className="font-heading text-2xl font-semibold text-zinc-50 flex items-center gap-2">
          <ArrowDownLeft size={22} className="text-amber-400" />
          Purchase Inward Calendar
        </h1>
        <p className="text-zinc-500 text-sm mt-0.5">
          What actually arrived, what is only billed, and what is still on the way — linked to dispatch.
        </p>
      </div>
      <MovementCalendar direction="inward" />
    </div>
  );
}
